import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Theme,
} from "@mui/material";
import { FC, useEffect, useState } from "react";
import { Button } from "../../../components/button/button";
import useScreenSize from "../../../utils/use-screen";
import { makeStyles } from "@mui/styles";
import { useApi } from "../../../api/use-api";
import { errorsList } from "../../../api/log/log";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";

const CELLS = [
  "id",
  "UId",
  "AId",
  "createdAt",
  "status",
  "error",
  "ip",
  "origin",
  "url",
  "method",
  "platform",
  "version",
  "userAgent",
  "cache",
  "screenWidth",
  "screenHeight",
  "body",
];

export const ErrorsList: FC = () => {
  const { api: errorsListApi, data: errors, loading } = useApi(errorsList);
  const { isDesktop } = useScreenSize();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(15);

  const classes = useClass();

  const {
    values,
    errors: formErrors,
    handleSubmit,
    handleChange,
    setFieldValue,
  } = useFormik({
    validationSchema: Yup.object({
      accountId: Yup.string(),
      userId: Yup.string(),
      date: Yup.string(),
    }),
    initialValues: {
      accountId: "",
      userId: "",
      date: "",
      status: "",
    },
    onSubmit: (data) => {
      errorsListApi({
        skip: page * limit,
        limit: limit,
        ...data,
      });
    },
  });

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const accountId = urlParams.get("accountId");
    errorsListApi({
      skip: 0,
      limit: 15,
      ...(accountId ? { accountId } : {}),
    });
    if (accountId) {
      setFieldValue("accountId", accountId);
    }
  }, [errorsListApi, setFieldValue]);

  return (
    <Box
      overflow={"none"}
      display="flex"
      flexDirection="column"
      maxWidth={"100%"}
    >
      <Box component="form" m={1} onSubmit={handleSubmit}>
        <TextField
          size="small"
          id="accountId"
          name="accountId"
          placeholder="accountId"
          value={values.accountId}
          error={!!formErrors.accountId}
          onChange={handleChange}
          className={classes.inputs}
        />
        <TextField
          size="small"
          id="userId"
          name="userId"
          placeholder="userId"
          value={values.userId}
          error={!!formErrors.userId}
          onChange={handleChange}
          className={classes.inputs}
        />
        <TextField
          size="small"
          id="date"
          name="date"
          placeholder="date"
          value={values.date}
          error={!!formErrors.date}
          onChange={handleChange}
          className={classes.inputs}
        />
        <TextField
          size="small"
          id="status"
          name="status"
          placeholder="status"
          value={values.status}
          error={!!formErrors.status}
          onChange={handleChange}
          className={classes.inputs}
        />
        <Button
          variant="outlined"
          type="submit"
          loading={loading}
          disabled={loading}
        >
          submit
        </Button>
      </Box>
      <Paper
        component={Grid}
        width={isDesktop ? "80vw" : "100vw"}
        overflow={"scroll"}
      >
        <TableContainer sx={{ width: "100%", overflowX: "scroll" }}>
          <Table aria-labelledby="tableTitle" size={"small"}>
            <TableHead>
              <TableRow>
                {CELLS.map((item) => (
                  <TableCell key={item}>{item}</TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {errors?.list.map((item) => {
                return (
                  <TableRow
                    key={item.id}
                    sx={{ background: item.status === 500 ? "#f8bbd0" : "" }}
                  >
                    <TableCell>{item.id}</TableCell>
                    <TableCell>
                      {item.userId && item.userId.slice(-8)}
                    </TableCell>
                    <TableCell>
                      <Link to={"/app/users/?accountId=" + item.accountId}>
                        {item.accountId && item.accountId.slice(-8)}
                      </Link>
                    </TableCell>
                    <TableCell>{item.createdAt?.replace("T", " , ")}</TableCell>
                    <TableCell>{item.status}</TableCell>
                    <TableCell>{item.error}</TableCell>
                    <TableCell>{item.ip}</TableCell>
                    <TableCell>{item.origin}</TableCell>
                    <TableCell>{item.url}</TableCell>
                    <TableCell>{item.method}</TableCell>
                    <TableCell>{item.platform}</TableCell>
                    <TableCell>{item.version}</TableCell>
                    <TableCell>{item.userAgent}</TableCell>
                    <TableCell>{item.cache}</TableCell>
                    <TableCell>{item.screenWidth}</TableCell>
                    <TableCell>{item.screenHeight}</TableCell>
                    <TableCell>{JSON.stringify(item.body)}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          rowsPerPageOptions={[15, 30, 60, 100, 1000]}
          count={errors?.count || 0}
          rowsPerPage={limit}
          page={page}
          onPageChange={(_, page) => {
            errorsListApi({
              skip: page * limit,
              limit: limit,
              accountId: values.accountId || "",
              date: values.date || "",
              userId: values.userId || "",
              status: values.status || "",
            });
            setPage(page);
          }}
          onRowsPerPageChange={(e) => {
            setLimit(parseInt(e.target.value));
            errorsListApi({
              skip: page * parseInt(e.target.value),
              limit: parseInt(e.target.value),
              accountId: values.accountId || "",
              date: values.date || "",
              userId: values.userId || "",
              status: values.status || "",
            });
          }}
        />
      </Paper>
    </Box>
  );
};

const useClass = makeStyles((theme: Theme) => ({
  inputs: {
    margin: `${theme.spacing(0, 0.5)} !important`,
  },
}));
